import { Component, OnInit, Input } from '@angular/core';
import { ActivatedRoute } from '@angular/router';
import { ModalService } from 'projects/mariano-max/src/app/core/app-shared/public-api';
import { GenericoSlideAnim } from '../etc/generico-animation'
import { MarianomGeneral } from '../marianom-general.service';
import { MenuMmaxInterface } from '../../components/etc/mmax-menu.interface';
import { ArticulosGeneral, EcommerceGenericoService } from 'projects/mariano-max/src/app/core/ecommerce-generico/public-api';
import { PorcentajePromo } from 'projects/mariano-max/src/app/core/ecommerce-generico/class/porcentaje-promo.class';

@Component({
  selector: 'carrito-generico',
  templateUrl: './carrito-generico.component.html',
  styleUrls: ['./carrito-generico.component.scss'],
  animations: [GenericoSlideAnim],
})

export class CarritoGenericoComponent implements OnInit {
  @Input('mode') modo: string;

  articulosconcantidad : ArticulosGeneral[] = [];
  total : number = 0;
  totales: number = 0;
  usaBultos: string = 'N';
  private scrollYAlAbrirCarrito = 0;
  constructor(
    private serv: MarianomGeneral,
    private genServ: EcommerceGenericoService,
    private route: ActivatedRoute,
    private modal: ModalService
  ) {
    this.modo = this.modo || 'normal';
    this.genServ.returnUsaBultos().subscribe(data => {
      this.usaBultos = (data || 'N').toString().trim();
      this.actualizarCarrito();
    });

    this.genServ.getTerminoDeIniciarCarro().subscribe({
      next: terminoDeCargar => {
        this.actualizarCarrito();
      }
    });

    this.genServ.getObservableSeAgregaronItemsAlCarrito().subscribe({
      next: nuevosArticulos => {
        this.actualizarCarrito();
      }
    });
  }

  ngOnInit(): void {
    //this.articulosconcantidad = this.genServ.getCarrito().slice();
    //this.total = this.genServ.getCantidadTotal()
    //this.totales = this.genServ.getTotal()
    this.actualizarCarrito();
  }

  get menus(): MenuMmaxInterface[] {
    return this.serv.rutas
  }

  get desplegado(): boolean {
    return this.serv.desplegado;
  }

  get sincronizandoCarritoConBack() {
    return this.genServ.getsincronizandoCarritoConBack();
  }

  get ocultarPrecios() {
    return this.genServ.isOcultarPrecio();
  }

  get descuentosGlobales() {
    return this.genServ.getPromocionesDescuentoGlobal().filter(
      promocion => this.genServ.getMontoDescuentoPromoGlobal(promocion) !== 0
    );
  }

  montoDescuentoGlobal(promocion: PorcentajePromo): number {
    return this.genServ.getMontoDescuentoPromoGlobal(promocion);
  }

  preguntarVaciar() {
    if (this.total === 0) {
      this.modal.open('modal-agregar-producto');
    }
    else {
      this.modal.open('vaciar-carro-modal-1');
    }
  }

  preguntarVaciarMobile() {
    this.modal.open('vaciar-carro-modal-2');
  }

  irAresumenPC() {
    //console.log('iraresumenpc',this.menus)
    if (this.total != 0) {
      for (let i = 0; i < this.menus.length; i++) {
        const element = this.menus[i];
        element.activo = false;
      }
      this.abriryCerrar();
      this.serv.navigator.irResumenCompra(this.route)
      this.serv.setMenuActivoNombre('carro');

    }
    else {
      this.modal.open('modal-agregar-producto');
    }

  }

  irAresumenMobile() {
    this.serv.navigator.irResumenCompra(this.route)
  }

  volverAtrasMobile() {
    this.serv.navigator.goLandPage(this.route);
  }

  abriryCerrar() {
    const abrir = !this.desplegado;
    this.serv.abrircerrarCart(abrir);

    const esMobile = window.matchMedia('(max-width: 599px)').matches;
    if (esMobile) {
      if (abrir) {
        // En mobile el panel pasa a quedar fixed pegado justo debajo de la
        // topbar (sin el hueco que dejaba el position:absolute anclado al
        // icono). Medimos el borde inferior real de la topbar (que es sticky)
        // en vez de hardcodear un alto que se rompe si la topbar cambia de
        // tamaño o hace wrap en pantallas chicas.
        const header = document.querySelector('.header-main') as HTMLElement;
        if (header) {
          document.documentElement.style.setProperty(
            '--cart-dropdown-top',
            `${header.getBoundingClientRect().bottom}px`
          );
        }

        // overflow:hidden en el body NO alcanza en iOS Safari: el scroll de
        // la pagina de atras igual "rebota" y se come el gesto en vez de
        // scrollear la lista interna del carrito. La forma confiable es
        // fijar el body en su posicion actual (position:fixed + top
        // negativo) y recien restaurar el scroll real al cerrar.
        this.scrollYAlAbrirCarrito = window.scrollY;
        document.body.classList.add('cart-scroll-lock');
        document.body.style.position = 'fixed';
        document.body.style.top = `-${this.scrollYAlAbrirCarrito}px`;
        document.body.style.left = '0';
        document.body.style.right = '0';
      } else {
        document.body.classList.remove('cart-scroll-lock');
        document.body.style.position = '';
        document.body.style.top = '';
        document.body.style.left = '';
        document.body.style.right = '';
        window.scrollTo(0, this.scrollYAlAbrirCarrito);
      }
    }
  }

  volverAlMenu() {
    this.serv.goLandPage();
    this.serv.navigator.goLandPage(this.route);
  }

  cerrarModale(nombre) {
    this.modal.close(nombre);
  }

  actualizarCarrito() {
    // Se excluye la linea virtual de descuento global (Tipo Cliente OL): en
    // este dropdown compacto se renderiza con selector de cantidad (mismo
    // template que un articulo real), lo cual no tiene sentido para un
    // descuento. El total ya la refleja via getTotal().
    this.articulosconcantidad = this.genServ.getCarrito().filter(
      articulo => !this.genServ.esLineaDescuentoGlobalTipoCliente(articulo)
    );
    if (this.usaBultos === 'S' || this.usaBultos === 'L') {
      this.total = this.articulosconcantidad.length;
    } else {
      this.total = this.genServ.getCantidadTotal();
    }
    this.totales = this.genServ.getTotal();
  }

}
